import { isValid, UTCDate } from '@/utils/dates';
import { InvoiceEvidenceView } from '../../../../../types/entity-types';

export const sortEvidencesByEffectiveDueDateOldestToNewest = (evidences: InvoiceEvidenceView[]) => {
  return evidences.sort((a, b) => {
    const sanitisedDueDateA =
      !a.billingDates?.dueDate || !isValid(new UTCDate(a.billingDates?.dueDate)) ? 'Unknown' : a.billingDates.dueDate;
    const sanitisedInvoiceDateA =
      !a.billingDates?.invoiceDate || !isValid(new UTCDate(a.billingDates?.invoiceDate))
        ? 'Unknown'
        : a.billingDates.invoiceDate;
    const sanitisedDueDateB =
      !b.billingDates?.dueDate || !isValid(new UTCDate(b.billingDates?.dueDate)) ? 'Unknown' : b.billingDates.dueDate;
    const sanitisedInvoiceDateB =
      !b.billingDates?.invoiceDate || !isValid(new UTCDate(b.billingDates?.invoiceDate))
        ? 'Unknown'
        : b.billingDates.invoiceDate;

    const effectiveDateA =
      sanitisedDueDateA !== 'Unknown'
        ? sanitisedDueDateA
        : sanitisedInvoiceDateA !== 'Unknown'
          ? sanitisedInvoiceDateA
          : 'Unknown';
    const effectiveDateB =
      sanitisedDueDateB !== 'Unknown'
        ? sanitisedDueDateB
        : sanitisedInvoiceDateB !== 'Unknown'
          ? sanitisedInvoiceDateB
          : 'Unknown';

    if (effectiveDateA === 'Unknown' && effectiveDateB !== 'Unknown') {
      return -1;
    }

    if (effectiveDateB === 'Unknown' && effectiveDateA !== 'Unknown') {
      return 1;
    }

    if (effectiveDateA === 'Unknown' && effectiveDateB === 'Unknown') {
      return 0;
    }

    return new UTCDate(effectiveDateA).getTime() - new UTCDate(effectiveDateB).getTime();
  });
};
